import React from 'react';
import { useParams } from 'react-router-dom';
import { SCOPE_OFFER } from '../../_CONST';
import TagForm from './components/tag/TagForm';

const CreateTagDocument = () => {
  const { offerId } = useParams();
  return (
    <TagForm
      scope={SCOPE_OFFER}
      offerId={offerId}
    />
  );
};

export default CreateTagDocument;
